var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1248 9.25529L10.0385 1.26807C9.59123 0.565193 8.83724 0.15625 8.00657 0.15625C7.1759 0.15625 6.4219 0.577973 5.97462 1.26807L0.888358 9.25529C0.402735 10.0093 0.377176 10.9294 0.81168 11.709C1.24619 12.4885 2.03852 12.9614 2.92031 12.9614H13.0801C13.9746 12.9614 14.767 12.4885 15.1887 11.709C15.6232 10.9294 15.5976 10.0093 15.1248 9.25529ZM7.38037 3.8751C7.38037 3.53005 7.66152 3.2489 8.00657 3.2489C8.35162 3.2489 8.63277 3.53005 8.63277 3.8751V7.61951C8.63277 7.96455 8.35162 8.24571 8.00657 8.24571C7.66152 8.24571 7.38037 7.96455 7.38037 7.61951V3.8751ZM7.99379 10.7377C7.46983 10.7377 7.06088 10.316 7.06088 9.80481C7.06088 9.29363 7.48261 8.87191 7.99379 8.87191C8.50497 8.87191 8.9267 9.29363 8.9267 9.80481C8.9267 10.316 8.51775 10.7377 7.99379 10.7377Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningBlue);
export default __webpack_public_path__ + "static/media/ic_warning_blue.5560c14bac02894a78985e3ff1fe37c4.svg";
export { ForwardRef as ReactComponent };